import { Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ApiConfig from '../../config/ApiConfig';
import { DATA_LIMIT } from '../../data/constants';
import {
  crypt,
  formatDate,
  getNewParameters,
  getObjectSubset,
  getParameters,
  downloadBlobFile,
  makeDateFromToday,
} from '../../lib/helper';
import {
  imageListingItemsSelector,
  setResetImagesDesc,
  setResetSoldImagesDescListing,
} from '../../redux/image';
import { customHistory } from '../../Route/CustomBrowserRouter';
import {
  imageListings,
  soldImageDescListings,
  getSoldImagesReport,
} from '../../Services/imageApis';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import MatTable from '../Tables/MatTable';
import AllFilters from '../Order/AllFilters';
import { getListOfImageKeywords } from '../../Services/keywordsApis';
import { toast } from 'react-toastify';
import { MaxByTypeData } from '../../data/userData';

const column = [
  {
    label: 'Image',
    id: 'image_url',
    format: (columnData) => (
      <span
        style={{ display: 'inline-block', width: '100%', textAlign: 'center' }}
      >
        <img style={{ maxWidth: 200, maxHeight: 200 }} src={`${columnData}`} />
      </span>
    ),
    numeric: 'center',
  },
  {
    label: 'Image ID',
    id: 'Name',
    format: (columnData) => (
      <span
        style={{ display: 'inline-block', whiteSpace: 'nowrap' }}
        onClick={() => {}}
      >
        {columnData}
      </span>
    ),
  },
  // {
  //   label: 'Rank',
  //   id: 'rank',
  //   format: (columnData) => (
  //     <span style={{ display: 'inline-block', whiteSpace: 'nowrap' }}>
  //       {columnData}
  //     </span>
  //   ),
  // },

  // {
  //   label: 'Contributor',
  //   id: 'is_contributor',
  //   format: (columnData, rowIndex, formatCallback, func, errors, row) => (<span style={{ display: 'inline-block' }}>
  //     <span style={{ display: 'inline-block', whiteSpace: "nowrap" }}><Typography variant='span' className='fontWeight600'>IsContributor:</Typography> {columnData == 1 ? 'yes' : 'No'}</span><br/>
  //     <span style={{ display: 'inline-block', whiteSpace: "nowrap" }}><Typography variant='span' className='fontWeight600'>Name:</Typography> {row?.contributor}</span>
  //   </span>)
  // },

  {
    label: 'Shoot ID',
    id: 'shootid',
    format: (columnData) => (
      <Link
        to={`/shoots/listing/${columnData}`}
        style={{
          display: 'inline-block',
          whiteSpace: 'nowrap',
          textDecoration: columnData ? 'underline' : 'none',
        }}
      >
        {columnData || 'N/A'}
      </Link>
    ),
  },

  {
    label: 'Sold Count',
    id: 'sold_count',
    format: (columnData) => (
      <span
        style={{ display: 'block', textAlign: 'center', whiteSpace: 'nowrap' }}
      >
        {columnData}
      </span>
    ),
    nextLine: false,
    numeric: 'center',
  },
];
const columnShoot = [
  {
    label: 'Shoot ID',
    id: 'shoot_id',
    format: (columnData) => (
      <Link
        to={`/shoots/listing/${columnData}`}
        style={{
          display: 'inline-block',
          whiteSpace: 'nowrap',
          textDecoration: columnData ? 'underline' : 'none',
        }}
      >
        {columnData || 'N/A'}
      </Link>
    ),
  },

  {
    label: 'Sold Count',
    id: 'shootsoldcount',
    format: (columnData) => (
      <span
        style={{ display: 'block', textAlign: 'center', whiteSpace: 'nowrap' }}
      >
        {columnData || 'N/A'}
      </span>
    ),
    nextLine: false,
    numeric: 'center',
  },
];

function AllImagesDesc() {
  const [shootTableListing, setShootTableListing] = useState([]);
  const [imageTableListing, setImageTableListing] = useState([]);
  const [page, setPage] = useState(1);
  const [allParams, setAllParams] = useState(getParameters());
  const [imageEditModal, setImageEditModal] = useState(false);
  const [editImageData, setEditImageData] = useState({});
  const { soldImagesDesc } = useSelector(imageListingItemsSelector);
  const dispatch = useDispatch();
  const [keywordForTheChoosenImage, setKeywordForTheChoosenImage] = useState(
    [],
  );
  const [limit, setLimit] = useState(20);
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState('image');
  const [filtersArray, setFiltersArray] = useState([
    {
      label: 'Type',
      id: 'type',
      type: 'select',
      linkedWith: null,
      value: 'image',
      onChange: async (e, index, value) => {
        setFiltersArray((prevState) => {
          let newState = [...prevState];
          // dispatch(setResetSoldImagesDescListing());
          newState[index].value = e.target.value;
          setType(e.target.value);
          if (e.target.value === 'shootid') {
            newState[1].isVisible = false;
            newState[2].isVisible = false;
            newState[1].value = '';
            newState[2].value = '';
            dispatch(setResetImagesDesc());
            setImageTableListing([]);
          } else {
            newState[1].isVisible = true;
            newState[2].isVisible = true;
            newState[1].value = makeDateFromToday(7);
            newState[2].value = new Date().toISOString().split('T')[0];
            dispatch(setResetImagesDesc());
            setShootTableListing([]);
          }
          setAllParams({
            page: String(1),
          });
          return newState;
        });
      },
      style: {},
      dataArr: MaxByTypeData,
      props: {},
      isVisible: true,
      rowFlexible:true,
      row:3
    },
    {
      label: 'From Date',
      id: 'start_date',
      type: 'input',
      linkedWith: null,
      value: makeDateFromToday(7),
      onChange: (e, index, value) => {
        setFiltersArray((prevState) => {
          let newState = [...prevState];
          newState[index].value = e.target.value;
          newState[1].value = e.target.value;
          return newState;
        });
      },
      style: {},
      dataArr: [],
      props: { type: 'date' },
      isVisible: true,
    },
    {
      label: 'To Date',
      id: 'end_date',
      type: 'input',
      linkedWith: null,
      value: new Date().toISOString().split('T')[0],
      onChange: (e, index, value) => {
        setFiltersArray((prevState) => {
          let newState = [...prevState];
          newState[index].value = e.target.value;
          return newState;
        });
      },
      style: {},
      dataArr: [],
      props: { type: 'date' },
      isVisible: true,
    },
    {
      label: 'Search Text',
      id: 'search',
      type: 'input',
      linkedWith: null,
      value: '',
      onChange: (e, index, value) => {
        setFiltersArray((prevState) => {
          let newState = [...prevState];
          // newState[index].value = e.target.value;
          newState[index].value = e?.target?.value?.trim();
          return newState;
        });
      },
      style: {},
      dataArr: [],
      props: {},
      isVisible: true,
    },
  ]);

  const handleFilter = (data, allDatavalues, dataWithValue) => {
    getListing(
      {
        page: String(1),
        ...dataWithValue,
      },
      true,
    );
    setAllParams({
      page: String(1),
      ...dataWithValue,
    });
  };

  const handleClear = () => {
    const data = getObjectSubset({ ...allParams }, 'tab', 'page');
    setAllParams(data);
    dispatch(setResetImagesDesc());
    setFiltersArray((prevState) => {
      let newState = [...prevState];
      // newState[0].isVisible = true;
      // newState[0].value = '';
      if (type === 'image') {
        newState[1].isVisible = true;
        newState[1].value = '';
        newState[2].isVisible = true;
        newState[2].value = '';
      } else {
        newState[1].isVisible = false;
        newState[1].value = '';
        newState[2].isVisible = false;
        newState[2].value = '';
      }
      newState[3].isVisible = true;
      newState[3].value = '';

      return newState;
    });
  };

  const getExportFile = async (params = {}, b, prepop) => {
    try {
      let payload = { ...allParams, ...params };
      delete payload.page;
      delete payload.limit;
      setLoading(true);
      if (type === 'shootid') {
        let resp = await getSoldImagesReport(prepop);
        if (resp?.status) {
          downloadBlobFile(resp.data, `ShootsHighestSoldCount`);
        }
      } else {
        if (prepop?.start_date && prepop?.end_date) {
          if (prepop?.start_date) {
            prepop['start_date'] =
              formatDate(prepop?.start_date, 'yyyy-mm-dd') + ' 00:00:00';
          }
          if (prepop?.end_date) {
            prepop['end_date'] =
              formatDate(prepop?.end_date, 'yyyy-mm-dd') + ' 23:59:59';
          }
          let resp = await getSoldImagesReport(prepop);
          if (resp?.status) {
            downloadBlobFile(resp.data, `ImagesHighestSoldCount`);
          }
        } else {
          toast.error('Start and End Date required!');
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const handleModal = (value = false) => {
    setImageEditModal(value);
    if (!value) {
      setTimeout(() => {
        setEditImageData({});
      }, 500);
    }
  };

  const getListing = async (params = {}) => {
    const payload = {
      page: String(1),
      limit: limit,
      insertion_status: 'old',
      // order_status: String(1),
      // type:type,
      ...allParams,
      ...params,
    };
    delete payload.type;
    if (payload?.start_date && payload?.end_date) {
      if (payload?.start_date) {
        payload['start_date'] =
          formatDate(payload?.start_date, 'yyyy-mm-dd') + '  00:00:00';
      }
      if (payload?.end_date) {
        payload['end_date'] =
          formatDate(payload?.end_date, 'yyyy-mm-dd') + '  23:59:59';
      }
    } else {
      if (type == 'image' && filtersArray[1]?.value &&filtersArray[2]?.value ) {
        payload['start_date'] = filtersArray[1]?.value + '  00:00:00';
        payload['end_date'] = filtersArray[2]?.value + '  23:59:59';
      }
    }
    payload['type'] = type;
    dispatch(soldImageDescListings(payload));
    setPage(Number(payload.page));
    setEditImageData({});
  };

  useEffect(() => {
    getListing();
  }, []);

  useEffect(() => {
    let params = getParameters();
    setAllParams(params);
  }, [location?.search]);

  useEffect(() => {
    let data = getNewParameters(allParams);
    if (data?.search !== location.search) {
      navigate(data.newUrl, { replace: false });
      if (data?.parameters?.page) {
        setPage(Number(data?.parameters?.page));
      }
    }
    getListing();
  }, [allParams]);

  const handleAllKeywordsForimage = async (data) => {
    let response = await getListOfImageKeywords(data?.Name);
    if (response?.status == 200) {
      setKeywordForTheChoosenImage(response?.data);
      handleImageKeywordModal(true);
    }
  };

  const handleAllFunctions = (data) => {
    setEditImageData(data);
    handleAllKeywordsForimage(data);
  };

  //making data format for table input

  useEffect(() => {
    if (soldImagesDesc?.items?.rows?.length >= 0) {
      if (type == 'shootid' && soldImagesDesc?.items?.rows[0]?.shootsoldcount) {
        let data = soldImagesDesc?.items?.rows?.map((item) => {
          return {
            shoot_id: item?.typeshoot_id,
            shootsoldcount: item?.shootsoldcount,
          };
        });
        setShootTableListing(data);
        setImageTableListing([]);
      } else if (type == 'image' && soldImagesDesc?.items?.rows[0]?.shoot_id) {
        let data = soldImagesDesc?.items?.rows?.map((item) => {
          return {
            image_url: `${ApiConfig.BASE_IMAGE_URL}${item?.shoot_id}/${item?.rank}-${item?.image_name}.jpg`,
            Name: item?.image_name,
            contributor: item,
            rank: item.rank, //=>edit
            rank1: item.rank1,
            shootid: item.shoot_id,
            is_contributor: item?.is_contributor,
            pricing: item.pricing, //=>edit
            suspendate: item.suspendate,
            createddate: item?.createddate,
            contributor: item.contributor,
            modelreleaseid: item?.modelreleaseid,
            available: item.available,
            type: item.type, //=>edit dropdown value [I, S]
            createddate: item.createdAt,
            imgstatus: item.imgstatus,
            suspend: item.imgstatus,
            keywords: item.Name, //=>edit
            sold_count: item.total_sold_count,
            is_star: item?.is_star,
            watermark: item?.watermark,
            // total_sold_count: item?.total_sold_count
          };
        });
        setImageTableListing(data);
        setShootTableListing([]);
      }
    }
  }, [soldImagesDesc.items]);

  useEffect(() => {
    dispatch(setResetImagesDesc());
    getListing();
  }, [type]);

  return (
    <>
      <MatTable
        loading={soldImagesDesc?.loading}
        showCheckbox={false}
        columns={type === 'image' ? column : columnShoot}
        data={
          soldImagesDesc?.loading
            ? []
            : type == 'image'
            ? imageTableListing
            : shootTableListing
        }
        onApplyFilter={(data = {}) => {
          getListing({
            page: String(1),
            start_date: '',
            end_date: '',
            ...getObjectSubset(data, 'start_date', 'end_date'),
          });
          if (Object.keys(data).length > 0) {
            setAllParams({
              ...allParams,
              page: String(1),
              ...getObjectSubset(data, 'start_date', 'end_date'),
            });
          } else {
            setAllParams({
              page: String(1),
            });
          }
        }}
        // action={actionBody}
        page={page}
        perPage={limit}
        showPageLimit={true}
        pageLimitArray={[10, 20, 50, 100, 200]}
        handleChangePageLimit={(e) => {
          setLimit(e.target.value);
          setAllParams({
            ...allParams,
            page: String('1'),
            limit: Number(e.target.value),
          });
        }}
        total={
          type == 'image'
            ? soldImagesDesc?.items?.count
            : soldImagesDesc?.items?.shoot_count || 0
        }
        setPage={setPage}
        handleSearch={(searchTerm) => {
          getListing({
            page: String(1),
            search: searchTerm,
          });
          setAllParams({
            ...allParams,
            page: String(1),
            search: searchTerm,
          });
        }}
        handlePageChange={(newPage) => {
          getListing({
            page: String(newPage),
          });
          setAllParams({
            ...allParams,
            page: String(newPage),
          });
        }}
        toolbarEnable={true}
        pagination={true}
        filtersUrlData={allParams || {}}
        customFilter={() => (
          <AllFilters
            filtersArray={filtersArray}
            handleClick={handleFilter}
            handleClear={handleClear}
            hasDownloadExcelButton={true}
            handleDownloadExcel={getExportFile}
            loading={loading}
          />
        )}
        disableSearch
      />
    </>
  );
}

export default AllImagesDesc;
